import classname from 'classname';
import React from 'react';
import styles from './dropdownbody.module.scss';
export default function Dropdownbody({ children, filter }) {
  return (
    <div className={classname(styles.dropdownbg, filter ? styles.filter : '')}>
      {children}
    </div>
  );
}

export const stylesForDropDown = styles;
